import React from "react";
import { Link } from "react-router-dom";

export default function ProductCard({ product }) {
  return (
    <Link
      data-testid={`product-card-${product.slug}`}
      to={`/shop/${product.slug}`}
      className="group block"
    >
      <div className="aspect-[4/5] overflow-hidden bg-[#EAE6DB] mb-6 relative">
        <img
          src={product.image_url}
          alt={product.name}
          loading="lazy"
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
        />
        <span className="absolute top-4 left-4 text-[10px] uppercase tracking-overline bg-[#FAF9F6] text-[#1A1A1A] px-2 py-1 border border-[#D5D1C5]">
          {product.category}
        </span>
      </div>
      <div className="flex justify-between items-start gap-4">
        <div>
          <h3 className="font-serif-display text-2xl md:text-3xl leading-tight tracking-tight">
            {product.name}
          </h3>
          <p className="text-sm text-[#7A7A7A] mt-1">{product.origin}</p>
        </div>
        <div className="text-right shrink-0">
          <p className="font-serif-display text-2xl text-[#C84B31]">${product.price_usd.toFixed(2)}</p>
          <p className="text-xs text-[#7A7A7A] uppercase tracking-overline">{product.unit_label}</p>
        </div>
      </div>
    </Link>
  );
}
